import {
  AUTO_DEBT_LOAD_REQUEST,
  UPDATE_REQUEST,
  UPDATE_REQUEST_FAILURE,
  UPDATE_REQUEST_SUCCESS,
  APPROVE_REQUEST,
  APPROVE_REQUEST_SUCCESS,
  APPROVE_REQUEST_FAILURE,
  REJECT_REQUEST,
  REJECT_REQUEST_SUCCESS,
  REJECT_REQUEST_FAILURE,
  CANCEL_REQUEST,
  CANCEL_REQUEST_SUCCESS,
  FETCH_REQUEST,
  FETCH_REQUEST_SUCCESS,
  SET_COMMENTS_SUCCESS,
  CHANGE_HISTORY_SUCCESS,
  INPROGRESS_STATUS_REQUEST,
  INPROGRESS_STATUS_SUCCESS,
  INPROGRESS_STATUS_FAILURE,
  FETCH_PAYMENT_SCHEDULE_SUCCESS,
  STATE_ERROR,
  FETCH_PAYMENT_SCHEDULE_FAILED,
  FETCH_PAYMENT_SCHEDULE_REQUEST,
    APPROVE_ERROR,
    RESET_PAYMENT_SCHEDULE
} from "../../actions/actionTypes";

const initialState = {
  currentRequestInfo: null,
  loading: false,
  debtLoading: false,
  error: null,
  changeHistory: [],
  isRejected: false,
  isApproved: false,
  changeStatusError: null,
  paymentSchedule: null,
  approveError: null
};

export const currentRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPROVE_ERROR:
    return {
      loading: false,
      error: null,
      approveError: action.payload,
    }
    case FETCH_PAYMENT_SCHEDULE_SUCCESS:
      return {
        paymentSchedule: action.payload,
        loading: false,
        error: null,
      }
      case FETCH_PAYMENT_SCHEDULE_REQUEST:
      return {
        loading: false,
        error: null,
      }
      case FETCH_PAYMENT_SCHEDULE_FAILED:
      return {
        loading: false,
        error: action.payload,
      }
    case FETCH_REQUEST:
    case INPROGRESS_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REQUEST_SUCCESS:
    case SET_COMMENTS_SUCCESS:
    case INPROGRESS_STATUS_SUCCESS:
      return {
        ...state,
        currentRequestInfo: action.payload,
        loading: false,
        debtLoading: false,
        error: null,
      };
    case AUTO_DEBT_LOAD_REQUEST:
      return {
        ...state,
        debtLoading: true,
        error: null,
      };
    case CHANGE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        changeHistory: action.payload.changelog,
      };
    case INPROGRESS_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        currentRequestInfo: action.payload,
        loading: false,
      };
    case UPDATE_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case APPROVE_REQUEST:
    case REJECT_REQUEST:
    case CANCEL_REQUEST:
      return {
        ...state,
        isApproved: false,
        isRejected: false,
        loading: true,
        changeStatusError: null,
      };
    case APPROVE_REQUEST_SUCCESS:
      return {
        ...state,
        isApproved: true,
        loading: false,
        currentRequestInfo: action.payload,
        paymentSchedule: null
      };
      case RESET_PAYMENT_SCHEDULE:
      return {
        ...state,
        isApproved: true,
        loading: false,
        paymentSchedule: null
      };
    case REJECT_REQUEST_SUCCESS:
    case CANCEL_REQUEST_SUCCESS:
      return {
        ...state,
        isRejected: true,
        loading: false,
        currentRequestInfo: action.payload,
      };
    case APPROVE_REQUEST_FAILURE:
    case REJECT_REQUEST_FAILURE:
      return {
        ...state,
        isApproved: false,
        isRejected: false,
        changeStatusError: action.payload,
        loading: false,
      };
    case STATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state;
  }
};
